import { render, staticRenderFns } from "./mcs-sheet.vue?vue&type=template&id=4b0c5630&scoped=true&"
import script from "./mcs-sheet.vue?vue&type=script&lang=js&"
export * from "./mcs-sheet.vue?vue&type=script&lang=js&"
import style0 from "./mcs-sheet.vue?vue&type=style&index=0&id=4b0c5630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c5630",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
